var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-apex-charts',{attrs:{"type":"radialBar","height":_vm.size,"options":_vm.chartOptions,"series":[_vm.similarity]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }